<template>
  <content-layout class="modal">
    <div class="result">
      <div class="top">
        <div class="title">
          Изменить город<br>
          на {{ $route.query.city }}?
        </div>
        <p class="message">Выбранные вами товары будут потеряны, заполненные контактные данные сохранятся.</p>
      </div>
      <div class="bottom">
        <button @click="$router.push({ name: 'RealCards' })" type="button" class="btn confirm">
          Поменять город
        </button>
        <button @click="dismiss" type="button" class="btn cancel">
          Отмена
        </button>
      </div>
      <a @click="dismiss" class="go-back content-box-component">Закрыть</a>
    </div>
  </content-layout>
</template>

<script>
import ContentLayout from '@/components/ContentLayout.vue'

export default {
  name: 'modal-city',
  data () {
    return {}
  },
  methods: {
    dismiss () {
      this.$localStorage.remove('new_city')
      this.$router.push({ name: 'RealCards' })
    }
  },
  components: {
    ContentLayout: ContentLayout
  }
}
</script>

<style scoped>
  .result {
    position: relative;
    font: 500 14px/1 Museo, sans-serif;
    width: 460px;
  }
  .top {
    padding: 30px 33px 25px;
    border-bottom: 1px solid rgba(139, 139, 139, .5);
  }
  .go-back {
    position: absolute;
    top: -5px;
    right: 15px;
    width: 20px;
    height: 20px;
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
    padding: 5px;
    opacity: .4;
  }
  .go-back:hover {
    opacity: 1;
  }
  .go-back::before,
  .go-back::after {
    content: '';
    display: block;
    background: #000;
    height: 3px;
    width: 25px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    transform-origin: center;
  }
  .go-back::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  .title {
    font: 700 48px/1 Bebas, sans-serif;
    margin-bottom: 10px;
  }
  .message {
    font-size: 18px;
    color: rgba(0, 0, 0, .8);
    margin: 0;
  }

  .bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 51px 33px;
    background-color: #ededed;
    box-shadow: inset 0 4px 12px 0 rgba(0, 0, 0, 0.05);
  }
  .confirm,
  .cancel {
    width: 255px;
    border-radius: 4px;
    text-transform: uppercase;
    line-height: 45px;
    font-size: 15px;
    font-weight: bold;
  }
  .confirm {
    background: #bc9665;
    color: #fff;
    margin-bottom: 10px;
  }
  .confirm:hover,
  .confirm:focus {
    background-color: #b68b55;
  }
  .cancel {
    background: transparent;
    border: 1px solid #000;
    opacity: .8;
  }

  /*=============================================>>>>>
  = Mobile =
  ===============================================>>>>>*/

  @media screen and (max-width: 1023px) {

    .result {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .top {
      background-color: #f6f6f7;
      border: none;
      padding: 0 20px 25px;
    }

    .go-back {
      background-color: #fff;
      box-shadow: 2.8px 2.8px 14px 0 rgba(0, 0, 0, 0.15);
      border-radius: 50%;
      overflow: hidden;
      padding: 17px;
      position: fixed;
      z-index: 2;
      top: 12px;
      right: 8px;
      opacity: .7;
    }
    .go-back::before,
    .go-back::after {
      width: 20px;
    }
    .title {
      font-size: 60px;
      margin-bottom: 5px;
    }
    .bottom {
      margin-top: auto;
      padding: 36px 33px;
    }
  }
</style>
